import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {ErrorLog} from '../../interfaces/core/error-log';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {ErrorLogFactory} from '../../factories/core/error-log-factory';


@Injectable({
  providedIn: 'root'
})
export class ErrorLogsTable extends SecureTable<ErrorLog> {
  constructor() {
    super(db.errorLogs);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<ErrorLog>({
        api: ['error-logs'],
        fromObject: ErrorLogFactory.fromObject,
        toRemote: ErrorLogFactory.toRemote
      })
    };
  }
}
